import { apiInstance } from '../apiInstance';
import { protectedResources } from '../../msalAuthConfig';

const headers = {
    'Content-Type': 'application/json',
}

const documentApi = {
    GetCompanyDocuments: (id) => {
        return apiInstance({
            method: 'GET',
            url: `${protectedResources.apiCompany.endpoint}/${id}/documents`,
            headers,
        });
    },

    GetCompanyDocumentById: (id, docId) => {
        return apiInstance({
            method: 'GET',
            url: `${protectedResources.apiCompany.endpoint}/${id}/document/${docId}`,
            headers,
        });
    },

    GetDocumentContentMapping: () => {
        return apiInstance({
            method: 'GET',
            url: `${protectedResources.apiAdvisoryGroup.endpoint}/document-content-mapping`,
            headers,
        })
    },

    CreateDocument: (data, onUploadProgress) => {
        const { companyId, documentContentMappingId, description, agId, meetingId, agMemberId, locationId,
            createdBy, modifiedBy, document, fileName, format, status } = data;

        const formData = new FormData();

        formData.append('companyId', companyId);
        formData.append('documentContentMappingId', documentContentMappingId);
        formData.append('description', description);
        formData.append('agId', agId);
        formData.append('meetingId', meetingId);
        formData.append('agMemberId', agMemberId);
        formData.append('locationId', locationId);
        formData.append('createdBy', createdBy);
        formData.append('modifiedBy', modifiedBy);
        formData.append('document', document);
        formData.append('fileName', fileName);
        formData.append('format', format);
        formData.append('status', status);

        return apiInstance({
            method: 'POST',
            url: `${protectedResources.apiAdvisoryGroup.endpoint}/document`,
            headers: {
                'Content-Type': 'multipart/form-data; boundary=AaB03x' +
                    '--AaB03x' +
                    'Content-Disposition: file' +
                    'Content-Type: png' +
                    'Content-Transfer-Encoding: binary' +
                    '...data... ' +
                    '--AaB03x--',
                Accept: 'application/json',
                type: 'formData',
            },
            data: formData,
            onUploadProgress
        })
    },

    UpdateDocument: (data, onUploadProgress) => {
        const { id, companyId, documentContentMappingId, description, agId, meetingId, agMemberId, locationId,
            createdBy, modifiedBy, document, fileName, format, status } = data;

        const formData = new FormData();

        formData.append('id', id);
        formData.append('companyId', companyId);
        formData.append('documentContentMappingId', documentContentMappingId);
        formData.append('description', description);
        formData.append('agId', agId);
        formData.append('meetingId', meetingId);
        formData.append('agMemberId', agMemberId);
        formData.append('locationId', locationId);
        formData.append('createdBy', createdBy);
        formData.append('modifiedBy', modifiedBy);
        formData.append('document', document);
        formData.append('fileName', fileName);
        formData.append('format', format);
        formData.append('status', status);

        return apiInstance({
            method: 'PUT',
            url: `${protectedResources.apiAdvisoryGroup.endpoint}/document`,
            headers: {
                "Content-Type": "multipart/form-data; boundary=AaB03x" +
                    "--AaB03x" +
                    "Content-Disposition: file" +
                    "Content-Type: png" +
                    "Content-Transfer-Encoding: binary" +
                    "...data... " +
                    "--AaB03x--",
                "Accept": "application/json",
                "type": "formData"
            },
            data: formData,
            onUploadProgress
        })
    }
}

export default documentApi;
